import { type WrappedInsightUrgentChampionAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import hourglassIcon from "../../assets/hourglass-wrapped.png";

interface UrgentChampionContentProps {
  attributes: WrappedInsightUrgentChampionAttributes;
}

export function UrgentChampionContent(props: UrgentChampionContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Text section - top left */}
      <Stack
        position="absolute"
        sx={{
          top: "12%",
          left: "7.7%",
        }}
        gap={1}
      >
        <Text variant="h3" color="white">
          Way to save the day!
        </Text>
        <Text variant="body1" color="white" sx={{ marginTop: 2 }}>
          You worked
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "5rem", lineHeight: 1 }}>
          {attributes.numberOfWorkedUrgentShifts}
          <Span sx={{ fontSize: "1rem", marginLeft: 1 }}>urgent shifts this year.</Span>
        </Text>
      </Stack>

      {/* Hourglass - positioned based on Figma: 300x322 at top 352px, left 32px, angle -15deg on 375x812 page */}
      <Box
        position="absolute"
        sx={{
          top: "43.3%", // 352 / 812
          left: "15.5%", // 32 / 375
        }}
      >
        <Image
          src={hourglassIcon}
          alt="Hourglass"
          width="80vw" // 300 / 375
          height="auto"
          sx={{ transform: "rotate(15deg)" }}
        />
      </Box>
    </Stack>
  );
}
